import axios from 'axios';

import { store } from '../../store';
import { resetProfile } from '../../store/profileSlice';

const baseUrl = import.meta.env.VITE_API_URL;

const PMAIS_URL = import.meta.env.VITE_PMAIS_URL;

const api = axios.create({
  baseURL: baseUrl,
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      store.dispatch(resetProfile());

      window.location.href = PMAIS_URL!;
    }
    return Promise.reject(error);
  },
);

export const cosmosApi = () => api;
